module.exports = __webpack_public_path__ + "static/mystra-symbol-DND3_FnP-9e561821955bf714ef5ef921fc09cb33.jpg";